if ($.browser.msie) {
    $("<style>")
        .prop("type", "text/css")
        .html("\
            .ms-d-grid {\
                display: -ms-grid;\
            }\
            @media (min-width: 700px) {\
                .ms-d-sm-grid {\
                    display: -ms-grid;\
                }\
            }\
            @media (min-width: 950px) {\
                .ms-d-md-grid {\
                    display: -ms-grid;\
                }\
            }\
            @media (min-width: 1110px) {\
                .ms-d-lg-grid {\
                    display: -ms-grid;\
                }\
            }")
        .appendTo("head");

    $(document).on('gridLayoutIeApply', function() {
        $('.d-grid').addClass('ms-d-grid').each(function (index, element) {
            applyGridLayout(element);
        });
        $('.d-sm-grid').addClass('ms-d-sm-grid').each(function (index, element) {
            applyGridLayout(element);
        });
        $('.d-md-grid').addClass('ms-d-md-grid').each(function (index, element) {
            applyGridLayout(element);
        });
        $('.d-lg-grid').addClass('ms-d-lg-grid').each(function (index, element) {
            applyGridLayout(element);
        });
    });

    function applyGridLayout(element) {
        var encounteredClasses = new Map();
        $(element.classList).each(function (index, cssClass) {
            if (['d-grid', 'ms-d-grid', 'd-sm-grid', 'ms-d-sm-grid', 'd-md-grid', 'ms-d-md-grid', 'd-lg-grid', 'ms-d-lg-grid',].indexOf(cssClass) >= 0) {
                //No need to check the 'display' classes themselves
                return;
            }
            var gridTemplateColumnsValue = encounteredClasses.get(cssClass);
            if (typeof gridTemplateColumnsValue === 'undefined') {
                gridTemplateColumnsValue = getStyleRuleValue('grid-template-columns', '.' + cssClass);
                encounteredClasses.set(cssClass, gridTemplateColumnsValue);
            }
            if (gridTemplateColumnsValue !== null) {
                var currentElement = $(element);
                currentElement.css('-ms-grid-columns', gridTemplateColumnsValue);
                var numberOfColumns = getNumberOfColumns(gridTemplateColumnsValue);
                var currentRow = 1;
                var currentColumn = 1;
                currentElement.children().each(function (index, child) {
                    var jQueryChild = $(child);
                    //For a start we assume that the existing grid-row/grid-column is applied as style attribute
                    var styleAttribute = jQueryChild.attr('style');
                    var existingMsGridRowValue = extractValueFromCssText(styleAttribute, '-ms-grid-row');
                    if (existingMsGridRowValue === null) {
                        var existingGridRowValue = extractValueFromCssText(styleAttribute, 'grid-row');
                        if (existingGridRowValue !== null) {
                            var existingGridRowNumber = Number(existingGridRowValue);
                            if (isNaN(existingGridRowNumber)) {
                                throw "Row spans are not supported.";
                            }
                            currentRow = existingGridRowNumber;
                        }
                        //Yes, this seriously _must_ be string...
                        jQueryChild.css("-ms-grid-row", String(currentRow));
                    }
                    var existingMsGridColumnValue = extractValueFromCssText(styleAttribute, '-ms-grid-column');
                    if (existingMsGridColumnValue === null) {
                        var existingGridColumnValue = extractValueFromCssText(styleAttribute, 'grid-column');
                        if (existingGridColumnValue !== null) {
                            var existingGridColumnNumber = Number(existingGridColumnValue);
                            if (isNaN(existingGridColumnNumber)) {
                                throw "Column spans are not supported.";
                            }
                            currentColumn = existingGridColumnNumber;
                        }
                        //Yes, this seriously _must_ be string...
                        jQueryChild.css("-ms-grid-column", String(currentColumn));
                    }
                    if (currentColumn < numberOfColumns) {
                        currentColumn++;
                    } else {
                        currentColumn = 1;
                        currentRow++;
                    }
                });
            }
        });
    }

    function getNumberOfColumns(gridTemplateColumnsValue) {
        //If any of this is needed, implemented it
        if (gridTemplateColumnsValue.indexOf('[') !== -1) {
            throw "Named lines are not supported.";
        } else if (gridTemplateColumnsValue.indexOf('minmax') !== -1) {
            throw "The function minmax is not supported.";
        } else if (gridTemplateColumnsValue.indexOf('fit-content') !== -1) {
            throw "The function fit-content is not supported.";
        } else if (gridTemplateColumnsValue.indexOf('repeat') !== -1) {
            throw "The function repeat is not supported.";
        }
        return gridTemplateColumnsValue.trim().split(' ').length;
    }

    //From https://stackoverflow.com/a/16966533 (modified to work in IE)
    function getStyleRuleValue(attribute, selector) {
        for (var i = 0, l = document.styleSheets.length; i < l; i++) {
            var sheet = (document.styleSheets)[i];
            if (!sheet || !sheet.cssRules) {
                continue;
            }
            for (var j = 0, k = sheet.cssRules.length; j < k; j++) {
                var rule = sheet.cssRules[j];
                //We only check whether the class is in the selector, not if the selector actually applies
                if (rule.selectorText && rule.selectorText.indexOf(selector) !== -1) {
                    var cssText = rule.style['cssText'];
                    return extractValueFromCssText(cssText, attribute);
                }
            }
        }
        return null;
    }

    function extractValueFromCssText(cssText, attribute) {
        var cssStyleRegex = new RegExp(attribute + ":([^;]+);");
        var regexResult = cssStyleRegex.exec(cssText);
        if (regexResult === null) {
            return null;
        }
        return regexResult[1].trim();
    }
}
